import { RevalidateValues, getRevalidateDuration } from "@/utils/revalidate";
import { notFound } from "next/navigation";

export const Obituary = {
  async getObituaryCompList() {
    const obituary = await fetch(
      `${process.env.NEXT_PUBLIC_DOMAIN_ROUTE}/api/obituary/component`,
      {
        next: {
          tags: ["global", "obituary", "obituary-component-list"],
          revalidate: getRevalidateDuration(RevalidateValues.DAY),
        },
      }
    );
    return obituary.json();
  },
  async getObituaryList(page: number) {
    const obituary = await fetch(
      `${process.env.NEXT_PUBLIC_DOMAIN_ROUTE}/api/obituary/list/?page=${page}`,
      {
        next: {
          tags: ["global", "obituary", "obituary-component-list"],
          revalidate: getRevalidateDuration(RevalidateValues.SECONDS),
        },
      }
    );
    return obituary.json();
  },
  async getObituarySearchList(term: string, page: number) {
    const obituary = await fetch(
      `${process.env.NEXT_PUBLIC_DOMAIN_ROUTE}/api/obituary/list/?page=${page}&name=${term}`,
      { cache: "no-store" }
    );
    return obituary.json();
  },
  async getObituary(slug: string) {
    const obituary = await fetch(
      `${process.env.NEXT_PUBLIC_DOMAIN_ROUTE}/api/obituary/${slug}/`,
      { cache: "no-store" }
    );
    if (obituary.status !== 200) {
      notFound();
    }
    let json = await obituary.json();
    // if (!json.published) {
    //   notFound();
    // }
    return json;
  },
  async getObituaryTributes(slug: string) {
    const obituary = await fetch(
      `${process.env.NEXT_PUBLIC_DOMAIN_ROUTE}/api/obituary/${slug}/tributes/`,
      { cache: "no-store" }
    );
    return obituary.json();
  },
  async getObituaryBook(slug: string) {
    const obituary = await fetch(
      `${process.env.NEXT_PUBLIC_DOMAIN_ROUTE}/api/obituary/${slug}/book/`,
      { cache: "no-store" }
    );
    return obituary.json();
  },
  async getObituaryBookPage(slug: string, page: number) {
    const obituary = await fetch(
      `${process.env.NEXT_PUBLIC_DOMAIN_ROUTE}/api/obituary/${slug}/book/${page}/`,
      { cache: "no-store" }
    );
    return obituary.json();
  },
};
